/*
 * @Autor: GeekMzy
 * @Date: 2023-12-08 20:44:51
 * @LastEditors: GeekMzy
 * @LastEditTime: 2023-12-08 20:44:51
 * @FilePath: \htwlgs-drainage-webv2-shiju\src\service\api-grid.ts
 * @Author: geekm的电脑
 */
import { AxiosRequestConfig, CancelToken } from 'axios'
import NProgress from 'nprogress'
import axiosInstance from './http' // 封装后的axios

export type RequestQueryParamsType = Record<string | number, any>

export class ApiGrid {
  private baseUrl: string =
    process.env.VUE_APP_MOCK == 'true' ? '/' : process.env.VUE_APP_BASE_URL + 'api/grid'

  private addQueryParam(query: RequestQueryParamsType, key: string) {
    return (
      encodeURIComponent(key) +
      '=' +
      encodeURIComponent(Array.isArray(query[key]) ? query[key].join(',') : query[key])
    )
  }

  protected addQueryParams(rawQuery?: RequestQueryParamsType): string {
    const query = rawQuery || {}
    const keys = Object.keys(query).filter((key) => 'undefined' !== typeof query[key])
    return keys.length
      ? `?${keys
          .map((key) =>
            typeof query[key] === 'object' && !Array.isArray(query[key])
              ? this.addQueryParams(query[key] as object).substring(1)
              : this.addQueryParam(query, key)
          )
          .join('&')}`
      : ''
  }

  public request = <T = any>(
    path: string,
    method: string,
    body?: any,
    cancelToken?: CancelToken
  ): Promise<T> => {
    const options = <AxiosRequestConfig>{
      method: method,
      data: body,
      url: `${this.baseUrl}${path}`,
      headers: {
        Accept: 'application/json, text/plain, */*',
      },
      cancelToken,
    }
    NProgress.start()
    const promise = axiosInstance.request(options)
    return promise.then(
      async (response: any) => {
        NProgress.done()
        return response.data
      },
      (reject) => {
        console.log(Error(reject))
        NProgress.done()
      }
    )
  }
}
